<div class="relative">
  <p-progressBar
    [value]="normalizedValue"
    [showValue]="false"
    [pTooltip]="tooltipContent"
    tooltipPosition="left">
  </p-progressBar>
  @if (normalizedComp) {
    <div class="comparison-line" [style.left.%]="normalizedComp"></div>
  }
  <ng-template #tooltipContent>
    <div class="">
      <strong>Wert:</strong> {{ getValueFormatted(value) }}<br />
      <strong>Von:</strong> {{ getValueFormatted(min) }}<br />
      <strong>Bis:</strong> {{ getValueFormatted(max) }}<br />
      <strong>AVG:</strong> {{ getValueFormatted(comp) }}<br />
    </div>
  </ng-template>
</div>
